/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiMacroprojectsMutationRequest,
  PostApiMacroprojectsMutationResponse,
} from '../models/PostApiMacroprojects.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiMacroprojectsMutationResponseSchema,
  postApiMacroprojectsMutationRequestSchema,
} from '../zod/postApiMacroprojectsSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiMacroprojectsMutationKey = () =>
  [{ url: '/api/macroProjects' }] as const;

export type PostApiMacroprojectsMutationKey = ReturnType<
  typeof postApiMacroprojectsMutationKey
>;

/**
 * {@link /api/macroProjects}
 */
export async function postApiMacroprojects(
  data: PostApiMacroprojectsMutationRequest,
  config: Partial<RequestConfig<PostApiMacroprojectsMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiMacroprojectsMutationRequestSchema.parse(data);
  const res = await request<
    PostApiMacroprojectsMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiMacroprojectsMutationRequest
  >({
    method: 'POST',
    url: `/api/macroProjects`,
    data: requestData,
    ...requestConfig,
  });
  return postApiMacroprojectsMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/macroProjects}
 */
export function usePostApiMacroprojects<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiMacroprojectsMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiMacroprojectsMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiMacroprojectsMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiMacroprojectsMutationKey();

  return useMutation<
    PostApiMacroprojectsMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiMacroprojectsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiMacroprojects(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
